import React from "react";
import pageStyles from "../styles/PageLayout.module.css";
import PageHeader from "../shared/PageHeader";
import PageContent from "../shared/PageContent";
import PhotoAnimationSection from "../sections/PhotoAnimationSection";

export function PhotoAnimationPage({ photoAnimation }) {
  return (
    <div className={pageStyles.page}>
      <PageHeader
        title="Оживить фото"
        description="Настраивайте стоимость, длительность, формат и стили AI-видео на основе фото."
      />
      <PageContent>
        <PhotoAnimationSection mode="page" state={photoAnimation.state} actions={photoAnimation.actions} />
      </PageContent>
    </div>
  );
}

export default PhotoAnimationPage;
